import React, { useState } from "react";
import Layout from "./Layout";
import { useNavigate } from "react-router-dom";
import InquiryModal from "modals/InquiryModal";
import { notice_site, detail_introduction } from "utils/linkData";
const Header = () => {
  let history = useNavigate();
  //모달창 open
  const [inquiryModalOpen, setInquiryModalOpen] = useState(false);
  return (
    <div>
      <div
        style={{ backgroundColor: "#F8F8F8" }}
        className="top-menu-right"
        id="font-SCD4"
      >
        <span className="span-header-20" onClick={() => history("/login")}>
          로그아웃
        </span>
        <span className="span-header-20" onClick={() => history("/mypage")}>
          마이페이지
        </span>
        <span
          className="span-header-50-p20"
          onClick={() => setInquiryModalOpen(true)}
        >
          문의
        </span>
        <span
          className="span-header-50-p20"
          onClick={() => window.open(notice_site)}
        >
          알림
        </span>
        <span
          className="span-header-50-p20"
          onClick={() => window.open(detail_introduction)}
        >
          소개
        </span>
      </div>
      <div style={{ clear: "both" }}></div>
      {inquiryModalOpen && (
        <InquiryModal setOpenModal={setInquiryModalOpen}></InquiryModal>
      )}
    </div>
  );
};

export default Header;
